import { apiAgent } from "../../axiosConfig"
import getApiUrl from "../../components/utils/UrlHelper"

export const send_otp_verification = (data_params) => {
    return apiAgent({
        method: "post",
        url: getApiUrl('send_otp_verification'),
        data: data_params
    })
}
export const resend_otp = (data_params) => {
    return apiAgent({
        method: "post",
        url: getApiUrl('post_resend_otp'),
        data: data_params
    })
}